require('expose-loader?exposes=jQuery,$!jquery');
require('jquery-migrate/dist/jquery-migrate.min.js');
require('jquery-ui/dist/jquery-ui');
require('jquery-validation');
